/** Minimal VM tracking surface — extend with getquote `vmTrackingHandler` when APIs are wired. */
export function recordPageLoad(..._args) {}

export async function recordVmTrackingPageCode(..._args) {}

export function handleRecordClick(..._args) {}
